export * from './list.component';



// WEBPACK FOOTER //
// ./src/app/pages/localization/components/wards/components/list/index.ts